/**
 * @generated SignedSource<<3d46699c746a3002a1011ab07fe41236>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Author_author$data = {
  readonly sellerPreferences: {
    readonly label: string | null;
    readonly scrollLogo: string | null;
    readonly urlLabel: string | null;
  } | null;
  readonly " $fragmentType": "Author_author";
};
export type Author_author$key = {
  readonly " $data"?: Author_author$data;
  readonly " $fragmentSpreads": FragmentRefs<"Author_author">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Author_author",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SellerPreferences",
      "kind": "LinkedField",
      "name": "sellerPreferences",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "label",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "urlLabel",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "scrollLogo",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Seller",
  "abstractKey": null
};

(node as any).hash = "5aae13ea9c53682323f4a04fa00d9f96";

export default node;
